import { IconLifebuoyFilled } from '@tabler/icons-react';

export default function TutorialButton({ onClick, label = 'Consejos', iconOnly = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={iconOnly ? label : undefined}
      title={iconOnly ? label : undefined}
      className={`flex items-center justify-center gap-2 font-semibold border-none cursor-pointer transition-all duration-200 ease-out active:scale-[0.96] ${
        iconOnly
          ? 'w-12 h-12 rounded-2xl bg-white/[0.04] hover:bg-white/[0.08]'
          : 'h-9 px-4 rounded-full bg-white text-black hover:brightness-110'
      }`}
      style={{ fontSize: '13px', fontFamily: '"Public Sans", sans-serif' }}
    >
      <IconLifebuoyFilled
        size={iconOnly ? 22 : 17}
        color={iconOnly ? 'rgba(255, 255, 255, 0.5)' : '#000000'}
      />
      {!iconOnly && label}
    </button>
  );
}
